<template>
  <v-card id="test" style="width: 100%;height: 100%;">
    <!--<v-btn @click="printView">列印測試</v-btn>-->
    <v-flex style="margin: 10px">
      <v-text-field style="width: 120px">

      </v-text-field>
    </v-flex>

    <v-flex style="margin: 10px">
      <v-btn  @click="testAlert('warning')">warning</v-btn>
      <v-btn  @click="testAlert('error')">error</v-btn>
      <v-btn  @click="testAlert('1')">單鈕</v-btn>
      <v-btn  @click="testAlert('2')">雙鈕</v-btn>
      <v-btn  @click="testAlert('3')">三鈕</v-btn>
      <v-btn  @click="testAlert('label')">換字</v-btn>
    </v-flex>

    <v-flex style="margin: 10px">
      <v-btn   @click="testErrorCode('test200')">200</v-btn>
      <v-btn   @click="testErrorCode('test300')">300</v-btn>
      <v-btn   @click="testErrorCode('test400')">400</v-btn>
      <v-btn   @click="testErrorCode('test401')">401</v-btn>
    </v-flex>
    <!--是否產生公告事項 提示視窗-->
    <v-dialog v-model="errorDialog"
              persistent
              width="50%"
              xs6 sm6 md6
              value="false"
              scrollable>
      <!--<delete-info-dialog @closeDelete="close" @confirmDelete="confirm" :delete-title="errorTitle" :delete-content="errorContent"></delete-info-dialog>-->
      <alert-win @closeDialog="close" @confirm="confirm" @retry="retry" :alert-title="errorTitle" :alert-msg="errorContent" :alery-type="aleryType" :alertButton="alertButton" :button1="button1" :button2="button2" :button3="button3"></alert-win>
    </v-dialog>

    <!-- 我是 snackbar -->
    <v-snackbar
            top
            :timeout="snTimeout"
            v-model="snStatus">
      {{snText}}
    </v-snackbar>

  </v-card>
</template>

<script>
    // import DeleteInfoDialog from './DeleteInfoDialog'
    import AlertWin from "./AlertWin";
    export default {
        name: "ErrorSampleCode",
        components:{AlertWin},
        data() {
            return {
                snTimeout:6000,
                snStatus:false,
                snText:'',
                errorDialog: false,
                errorTitle:'',
                errorContent:'',

                aleryType:'',
                alertButton:1,
                button1:'確定',
                button2:'取消',
                button3:'重試',

                ruleTest:[],
            }
        },
        methods:{
            close(){
                this.errorDialog=false;
            },
            confirm(){ //確定新增公告
                this.errorDialog=false;
            },
            retry(){
                this.snStatus=true;
                this.snText = 'Retry processing...';
                this.errorDialog = false;
            },
            testErrorCode: function (testError) {
                let url = "https://172.16.1.60:8443/iFormSys2/rest/testhttpstatus/"+testError;
                this.$http.get(url)
                    .then(response =>{
                        if(response.data.status == 'INFO'){
                            this.snStatus=true;
                            this.snText = response.data.message;
                        }
                    })
                    .catch(error =>  {
                        try {
                            console.log(error.response)
                            switch (error.response.status){
                                case 300:
                                case 400:
                                case 401:
                                    this.errorDialog = true;
                                    this.errorTitle = "Error " + error.response.status;
                                    this.errorContent = error.response.data.message;
                                    break;
                                case 404:
                                    this.errorDialog = true;
                                    this.errorTitle = "Error " + error.response.status;
                                    this.errorContent ="找不到頁面";
                                    break;
                                case 500:
                                    this.errorDialog = true;
                                    this.errorTitle = "Error " + error.response.status;
                                    this.errorContent = "伺服器錯誤";
                                    break;
                                default:
                                    this.errorDialog = true;
                                    this.errorTitle = "Error " + error.response.status;
                                    this.errorContent =error.response.data;
                            }

                        } catch(err) {
                            console.log(err.response.data.message)
                        }
                    });

            },

            testAlert(type){
                this.errorTitle = "系統訊息";
                this.alertButton = 1;
                this.aleryType = 'default';
                this.button1 = '確定';
                this.button2 = '取消';
                this.button3 = '重試';

                switch(type)
                {
                    case 'warning':
                        this.errorDialog = true;
                        this.errorTitle = "Warning";
                        this.errorContent = "警告 訊息內容";
                        this.aleryType = 'warning';
                        break;
                    case 'error':
                        this.errorDialog = true;
                        this.errorTitle = "Error";
                        this.errorContent = "錯誤 訊息內容";
                        this.aleryType = 'error';
                        break;
                    case '1':
                        this.errorDialog = true;
                        this.errorTitle = "系統訊息";
                        this.errorContent = "單鈕";
                        this.alertButton = 1;
                        break;
                    case '2':
                        this.errorDialog = true;
                        this.errorTitle = "系統訊息";
                        this.errorContent = "雙鈕";
                        this.alertButton = 2;
                        break;
                    case '3':
                        this.errorDialog = true;
                        this.errorTitle = "系統訊息";
                        this.errorContent = "三鈕";
                        this.alertButton = 3;
                        break;
                    case 'label':
                        this.errorDialog = true;
                        this.errorTitle = "修改按鈕文字";
                        this.errorContent = "修改按鈕中的文字";
                        this.alertButton = 2;
                        this.button1 = '是';
                        this.button2 = '否';
                        break;

                }
            },

            printView(){
                // var w = window.open("about:blank");
                // w.document.write(htmlPage);
                // if (navigator.appName == 'Microsoft Internet Explorer') window.print();
                // else w.print();

                // var getMyFrame = document.getElementById('app');
                // getMyFrame.focus();
                // getMyFrame.contentWindow.print();
            },

        }

    }
</script>

<style scoped>

</style>
